module.exports = __webpack_public_path__ + "static/media/culture-primary.f785e84b.jpg";